// カートページ上のギフト設定を cart attributes / line item properties / 有料包装紙商品と同期する。
document.addEventListener('DOMContentLoaded', () => {
  const wrappingRoot = document.querySelector('[data-paid-wrapping-sync-root]');
  const cartForm = document.getElementById('cart');
  let cartAttributesSnapshot = window.cartAttributesSnapshot || {};

  if (!cartForm) return;

  let saveAttributesTimer = null;

  const wrappingWrappers = wrappingRoot
    ? Array.from(wrappingRoot.querySelectorAll('.wrapping-option__wrapper'))
    : [];

  const allPaidVariantIds = Array.from(
    new Set(
      [
        ...(wrappingRoot
          ? Array.from(
              wrappingRoot.querySelectorAll('.js-wrapping-paper-radio[data-paid-wrapping="true"][data-variant-id]')
            )
          : []),
        ...Array.from(document.querySelectorAll('[data-paid-wrapping-line-item][data-variant-id]'))
      ]
        .map((item) => Number(item.dataset.variantId))
        .filter((variantId) => Number.isFinite(variantId) && variantId > 0)
    )
  );

  let isSyncing = false;
  let hasPendingWrappingPaperChange = false;
  let isCheckingCartStructure = false;
  let cartStructureCheckTimer = null;
  let trackedTargetsSnapshot = [];

  function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  function getNextWrappingId() {
    const usedIds = new Set(
      getTrackedTargetsByType(getTrackedTargetsFromDom(), 'wrapping')
        .map((target) => Number(target.wrappingId))
        .filter((wrappingId) => Number.isInteger(wrappingId) && wrappingId > 0)
    );

    let nextId = 1;
    while (usedIds.has(nextId)) {
      nextId += 1;
    }

    return String(nextId);
  }

  function getNextCardId() {
    const usedIds = new Set(
      getTrackedTargetsByType(getTrackedTargetsFromDom(), 'card')
        .map((target) => Number(target.cardId))
        .filter((cardId) => Number.isInteger(cardId) && cardId > 0)
    );

    let nextId = 1;
    while (usedIds.has(nextId)) {
      nextId += 1;
    }

    return String(nextId);
  }

  function getWrappingAttributeInputs() {
    return Array.from(document.querySelectorAll('[data-paid-wrapping-sync-root] [name^="attributes["]'));
  }

  // メインラッピング/カード商品行の現在状態を読む。
  function getTrackedTargetsFromDom() {
    return Array.from(document.querySelectorAll('[data-tracked-line-item]')).map((item) => ({
      type: item.dataset.itemType || '',
      productId: Number(item.dataset.productId),
      productTitle: item.dataset.productTitle || '',
      wrappingId: item.dataset.wrappingId || '',
      cardId: item.dataset.cardId || '',
      quantity: Number(item.dataset.quantity),
      paperPossible: item.dataset.paperPossible === 'true',
      specialPaperPossible: item.dataset.specialPaperPossible === 'true',
      noshiPossible: item.dataset.noshiPossible === 'true',
      specialNoshiPossible: item.dataset.specialNoshiPossible === 'true'
    }));
  }

  function normalizeTrackedTargets(targets) {
    return targets
      .filter((target) => Number.isFinite(target.productId) && Number.isFinite(target.quantity))
      .sort((a, b) => {
        const left = `${a.type}:${a.productId}:${a.productTitle}:${a.wrappingId}:${a.cardId}:${a.quantity}:${a.paperPossible}:${a.specialPaperPossible}:${a.noshiPossible}:${a.specialNoshiPossible}`;
        const right = `${b.type}:${b.productId}:${b.productTitle}:${b.wrappingId}:${b.cardId}:${b.quantity}:${b.paperPossible}:${b.specialPaperPossible}:${b.noshiPossible}:${b.specialNoshiPossible}`;
        return left.localeCompare(right);
      });
  }

  function getWrappingAttributePrefix(target) {
    const wrappingId = target.wrappingId || `${target.productId}-${target.productTitle}`;
    return `ラッピング-${wrappingId}`;
  }

  function setWrappingInputsDisabled(disabled) {
    if (!wrappingRoot) return;

    wrappingRoot.classList.toggle('is-syncing', disabled);

    const syncStatus = wrappingRoot.querySelector('.wrapping-sync-status');
    if (syncStatus) {
      syncStatus.setAttribute('aria-hidden', disabled ? 'false' : 'true');
    }

    getWrappingAttributeInputs().forEach((input) => {
      input.disabled = disabled;
    });
  }

  // cart attributes / note だけを保存する。
  function getCartAttributeFormData(preparedFormData = null) {
    const sourceFormData = preparedFormData || new FormData(cartForm);
    const formData = new FormData();

    sourceFormData.forEach((value, key) => {
      if (key === 'note' || key === 'sections_url' || key.startsWith('attributes[')) {
        formData.append(key, value);
      }
    });

    if (!formData.has('sections_url')) {
      formData.append('sections_url', window.location.pathname);
    }

    return formData;
  }

  async function persistCartAttributes(preparedFormData = null) {
    const formData = getCartAttributeFormData(preparedFormData);

    const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      },
      body: formData
    });

    if (!response.ok) {
      throw new Error('Failed to persist cart attributes.');
    }

    formData.forEach((value, key) => {
      const attributeMatch = key.match(/^attributes\[(.*)\]$/);
      if (!attributeMatch) return;

      cartAttributesSnapshot[attributeMatch[1]] = value;
    });
  }

  function scheduleAttributePersist() {
    clearTimeout(saveAttributesTimer);
    saveAttributesTimer = setTimeout(() => {
      persistCartAttributes().catch((error) => {
        console.error(error);
      });
    }, 300);
  }

  // のしなし・特別のしは名入れ対象外のため、名前入力欄を隠して古い入力値を消す。
  function updateNoshiNameField(wrapper) {
    const selectedNoshi = wrapper.querySelector('.js-noshi-kind-radio:checked');
    const nameField = wrapper.querySelector('.js-noshi-name-field');
    const nameInput = nameField ? nameField.querySelector('.noshi-name') : null;

    if (!selectedNoshi || !nameField || !nameInput) return false;

    const isNoNoshi = selectedNoshi.value === 'なし';
    const isSpecialNoshi = selectedNoshi.dataset.specialNoshi === 'true';
    const shouldHideNameField = isNoNoshi || isSpecialNoshi;
    nameField.hidden = shouldHideNameField;

    if (!shouldHideNameField || !nameInput.value) return false;

    nameInput.value = '';
    return true;
  }

  // メインラッピング/カード追加時に識別用 line item property を付け、送信直前に attributes を保存する。
  function bindWrappingAddFormSubmitSaver() {
    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.matches('[data-wrapping-add-form]')) return;

      const actionPath = new URL(form.action, window.location.origin).pathname;
      if (!actionPath.endsWith('/cart/add')) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      if (form.dataset.isSubmitting === 'true') return;

      form.dataset.isSubmitting = 'true';
      clearTimeout(saveAttributesTimer);

      const cardIdInput = form.querySelector('[name="properties[_wrapping_card_id]"]');
      if (cardIdInput && !cardIdInput.value) {
        cardIdInput.value = getNextCardId();
      }

      const wrappingIdInput = form.querySelector('[name="properties[_wrapping_id]"]');
      if (wrappingIdInput && !wrappingIdInput.value) {
        wrappingIdInput.value = getNextWrappingId();
      }

      const preparedFormData = new FormData(cartForm);
      preparedFormData.append('sections_url', window.location.pathname);

      (async () => {
        try {
          await persistCartAttributes(preparedFormData);

          HTMLFormElement.prototype.submit.call(form);
        } catch (error) {
          console.error(error);
          form.dataset.isSubmitting = 'false';
          window.alert('ラッピング内容の保存に失敗しました。時間をおいてもう一度お試しください。');
        }
      })();
    }, true);
  }

  // 選択中の有料包装紙variantごとの必要数量を集計する。
  function getDesiredPaidWrappingCounts(activeWrappingIds = null) {
    const desiredCounts = new Map();

    wrappingWrappers.forEach((wrapper) => {
      if (activeWrappingIds && !activeWrappingIds.has(wrapper.dataset.wrappingId || '')) return;

      const selectedInput = wrapper.querySelector('.js-wrapping-paper-radio:checked');
      if (!selectedInput || selectedInput.dataset.paidWrapping !== 'true') return;

      const variantId = Number(selectedInput.dataset.variantId);
      if (!Number.isFinite(variantId) || variantId <= 0) return;

      desiredCounts.set(variantId, (desiredCounts.get(variantId) || 0) + 1);
    });

    return desiredCounts;
  }

  // カート内の有料包装紙商品と、画面上の選択状態の差分を作る。
  async function getPaidWrappingSyncState(activeWrappingIds = null) {
    const desiredCounts = getDesiredPaidWrappingCounts(activeWrappingIds);
    const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);

    if (!cartResponse.ok) {
      throw new Error('Failed to fetch cart.');
    }

    const cart = await cartResponse.json();
    const updates = {};
    let hasCartChanges = false;

    allPaidVariantIds.forEach((variantId) => {
      updates[variantId] = desiredCounts.get(variantId) || 0;
    });

    cart.items.forEach((item) => {
      if (!allPaidVariantIds.includes(item.variant_id)) return;

      if (updates[item.variant_id] !== item.quantity) {
        hasCartChanges = true;
      }
    });

    desiredCounts.forEach((quantity, variantId) => {
      if (!quantity) return;

      const existingItem = cart.items.find((item) => item.variant_id === variantId);
      if (!existingItem) {
        hasCartChanges = true;
      }
    });

    return {
      hasCartChanges,
      updates
    };
  }

  // 有料包装紙商品の数量差分を cart/update.js へ反映する。
  async function syncPaidWrappingLineItems(activeWrappingIds = null) {
    const { hasCartChanges, updates } = await getPaidWrappingSyncState(activeWrappingIds);

    if (!hasCartChanges) {
      return false;
    }

    const updateResponse = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        updates
      })
    });

    if (!updateResponse.ok) {
      throw new Error('Failed to sync paid wrapping quantities.');
    }

    return true;
  }

  async function ensurePaidWrappingSynced(activeWrappingIds = null, maxAttempts = 5, intervalMs = 150) {
    let didSync = false;

    for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
      const hasCartChanges = await syncPaidWrappingLineItems(activeWrappingIds);

      if (!hasCartChanges) {
        return didSync;
      }

      didSync = true;
      await delay(intervalMs);
    }

    return didSync;
  }

  function getTrackedTargetsByType(targets, type) {
    return targets.filter((target) => target.type === type);
  }

  // cart.js のDOM差し替えでメインラッピング/カード構成が変わったか判定する。
  function hasTrackedStructureChanged(currentTargets) {
    return JSON.stringify(normalizeTrackedTargets(trackedTargetsSnapshot)) !== JSON.stringify(normalizeTrackedTargets(currentTargets));
  }

  // cart.js のDOM差し替えが反映されるまで待つ。
  async function waitForTrackedTargetsChange(maxAttempts = 10, intervalMs = 150) {
    let currentTargets = getTrackedTargetsFromDom();

    for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
      if (hasTrackedStructureChanged(currentTargets)) {
        return currentTargets;
      }

      await delay(intervalMs);
      currentTargets = getTrackedTargetsFromDom();
    }

    return currentTargets;
  }

  // 現在のメインラッピングから、残すべき cart attribute 名を作る。
  function getExpectedWrappingAttributeKeys(targets) {
    const keys = [];
    const wrappingTargets = getTrackedTargetsByType(targets, 'wrapping');

    wrappingTargets.forEach((target) => {
      const wrappingOption = getWrappingAttributePrefix(target);
      const noshiKind = `${wrappingOption}-のしの種類`;
      const noshiName = `${wrappingOption}-のしのお名前`;
      const wrappingPaperAttr = `${wrappingOption}-包装紙`;
      const wrappingTargetAttr = `${wrappingOption}-対象商品`;
      const wrappingTargetAttrTwo = `${wrappingOption}-対象商品2`;

      keys.push(wrappingTargetAttr);

      if (target.productTitle.includes('２本')) {
        keys.push(wrappingTargetAttrTwo);
      }

      if (target.paperPossible || target.specialPaperPossible) {
        keys.push(wrappingPaperAttr);
      }

      if (target.noshiPossible || target.specialNoshiPossible) {
        keys.push(noshiKind);
        keys.push(noshiName);
      }
    });

    return keys;
  }

  function getStaleGiftAttributeKeys(targets, cartAttributes) {
    const expectedKeys = new Set(getExpectedWrappingAttributeKeys(targets));

    return Object.keys(cartAttributes).filter((key) => {
      const isGiftAttribute = key.startsWith('ラッピング') || key.startsWith('カード') || key.endsWith('のメッセージ');
      const hasValue = Boolean(String(cartAttributes[key]).trim());
      return isGiftAttribute && hasValue && !expectedKeys.has(key);
    });
  }

  // 不要になった有料包装紙商品をカートから消す。
  async function clearPaidWrappingItems() {
    if (!allPaidVariantIds.length) return false;

    const updates = {};
    allPaidVariantIds.forEach((variantId) => {
      updates[variantId] = 0;
    });

    const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ updates })
    });

    if (!response.ok) {
      throw new Error('Failed to clear paid wrapping items.');
    }

    return true;
  }

  async function hasRemainingPaidWrappingItems() {
    const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);

    if (!cartResponse.ok) {
      throw new Error('Failed to fetch cart while checking paid wrapping items.');
    }

    const cart = await cartResponse.json();

    return cart.items.some((item) => allPaidVariantIds.includes(item.variant_id) && item.quantity > 0);
  }

  // 有料包装紙の削除が cart.js に反映されるまで確認する。
  async function clearPaidWrappingItemsAndWait(maxAttempts = 6, intervalMs = 200) {
    let didClear = false;

    for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
      const hasRemainingItems = await hasRemainingPaidWrappingItems();

      if (!hasRemainingItems) {
        return didClear;
      }

      await clearPaidWrappingItems();
      didClear = true;
      await delay(intervalMs);
    }

    return didClear;
  }

  // 不要になった cart attributes を掃除する。
  async function clearStaleGiftAttributes(staleKeys) {
    if (!staleKeys.length) return false;

    const attributes = {};
    staleKeys.forEach((key) => {
      attributes[key] = '';
    });

    const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ attributes })
    });

    if (!response.ok) {
      throw new Error('Failed to clear stale gift attributes.');
    }

    staleKeys.forEach((key) => {
      delete cartAttributesSnapshot[key];
    });

    return true;
  }

  async function cleanupStaleGiftAttributes(targets = getTrackedTargetsFromDom()) {
    const staleKeys = getStaleGiftAttributeKeys(targets, cartAttributesSnapshot);
    return await clearStaleGiftAttributes(staleKeys);
  }

  // メインラッピングなしで残った有料包装紙だけの状態を掃除する。
  async function cleanupOrphanedPaidWrapping() {
    if (wrappingRoot && wrappingWrappers.length) return false;
    if (!allPaidVariantIds.length) return false;

    return await clearPaidWrappingItemsAndWait();
  }

  // 包装紙選択変更時に attributes と有料包装紙商品を同期する。
  async function handleWrappingPaperChange() {
    if (isSyncing) {
      hasPendingWrappingPaperChange = true;
      return;
    }

    isSyncing = true;
    let shouldReload = false;
    let shouldLockInputs = false;

    try {
      const preparedFormData = new FormData(cartForm);
      preparedFormData.append('sections_url', window.location.pathname);

      const syncState = await getPaidWrappingSyncState();
      shouldLockInputs = syncState.hasCartChanges;

      if (shouldLockInputs) {
        setWrappingInputsDisabled(true);
      }

      await persistCartAttributes(preparedFormData);
      const hasCartChanges = shouldLockInputs
        ? await syncPaidWrappingLineItems()
        : false;

      if (hasCartChanges) {
        shouldReload = true;
        window.location.reload();
      }
    } catch (error) {
      console.error(error);
      shouldReload = true;
      window.location.reload();
    } finally {
      if (shouldLockInputs && !shouldReload) {
        setWrappingInputsDisabled(false);
      }
      isSyncing = false;

      if (!shouldReload && hasPendingWrappingPaperChange) {
        hasPendingWrappingPaperChange = false;
        handleWrappingPaperChange();
      }
    }
  }

  async function handleCartStructureChange() {
    if (isCheckingCartStructure) return;

    isCheckingCartStructure = true;

    try {
      const currentTargets = await waitForTrackedTargetsChange();
      if (!hasTrackedStructureChanged(currentTargets)) return;

      trackedTargetsSnapshot = currentTargets;
      const activeWrappingIds = new Set(
        getTrackedTargetsByType(currentTargets, 'wrapping')
          .map((target) => target.wrappingId)
          .filter(Boolean)
      );
      const hasRemainingMainWrappingTargets = activeWrappingIds.size > 0;

      if (!hasRemainingMainWrappingTargets) {
        await clearPaidWrappingItemsAndWait();
      } else {
        await ensurePaidWrappingSynced(activeWrappingIds);
      }

      await cleanupStaleGiftAttributes(currentTargets);

      window.location.reload();
    } catch (error) {
      console.error(error);
      window.location.reload();
    } finally {
      isCheckingCartStructure = false;
    }
  }

  function bindCartStructureWatcher() {
    const cartItemsRoot = document.getElementById('main-cart-items');
    if (!cartItemsRoot) return;
    const contentsRoot = cartItemsRoot.querySelector('.js-contents');
    if (!contentsRoot) return;

    trackedTargetsSnapshot = getTrackedTargetsFromDom();

    const observer = new MutationObserver(() => {
      clearTimeout(cartStructureCheckTimer);
      cartStructureCheckTimer = setTimeout(() => {
        handleCartStructureChange().catch((error) => {
          console.error(error);
        });
      }, 100);
    });

    observer.observe(contentsRoot, {
      childList: true,
      subtree: true
    });
  }

  // ページ読み込み直後に、不要な有料包装紙商品や古い attributes を掃除する。
  (async () => {
    try {
      const didCleanupPaidWrapping = await cleanupOrphanedPaidWrapping();
      const didCleanupAttributes = await cleanupStaleGiftAttributes();

      if (didCleanupPaidWrapping || didCleanupAttributes) {
        window.location.reload();
      }
    } catch (error) {
      console.error(error);
    }
  })();

  bindCartStructureWatcher();
  bindWrappingAddFormSubmitSaver();

  if (!wrappingRoot || !wrappingWrappers.length) return;

  let clearedNoshiNameOnLoad = false;
  wrappingWrappers.forEach((wrapper) => {
    if (updateNoshiNameField(wrapper)) clearedNoshiNameOnLoad = true;
  });
  if (clearedNoshiNameOnLoad) {
    scheduleAttributePersist();
  }

  // ラッピングオプション入力の変更を attributes / 有料包装紙商品へ反映する。
  wrappingRoot.addEventListener('change', (event) => {
    if (
      !(
        event.target instanceof HTMLInputElement ||
        event.target instanceof HTMLSelectElement ||
        event.target instanceof HTMLTextAreaElement
      )
    ) return;

    if (
      event.target.classList.contains('js-wrapping-paper-radio')
    ) {
      handleWrappingPaperChange();
      return;
    }

    if (event.target.classList.contains('js-noshi-kind-radio')) {
      const wrapper = event.target.closest('.wrapping-option__wrapper');
      if (wrapper) updateNoshiNameField(wrapper);
    }

    scheduleAttributePersist();
  });

  wrappingRoot.addEventListener('input', (event) => {
    if (!(event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement)) return;

    if (
      event.target.classList.contains('js-wrapping-paper-radio')
    ) {
      return;
    }

    scheduleAttributePersist();
  });
});
